export default {
    items: [
        {
            name: 'Beranda',
            url: '/landing-page',
            icon: 'fa fa-home',
            role: []
        },
        // {
        //     name: 'Tiket',
        //     url: '/tiket',
        //     icon: 'fa fa-ticket',
        //     role: []
        // },
        {
            title: true,
            name: 'Operasional',
            role: []
        },
        {
            name: 'Engine',
            url: '/engine',
            icon: 'fa fa-cogs',
            role: [0, 1, 2, 3, 4, 7, 8, 10],
            children: [
                {
                    name: 'Dashboard',
                    url: '/engine/dashboard',
                    // icon: 'fa fa-dashboard',
                    role: []
                },
                {
                    name: 'Tipe Engine',
                    url: '/engine/tipe',
                    // icon: 'fa fa-cube',
                    role: [8]
                },
                {
                    name: 'Daftar Engine',
                    url: '/engine/list',
                    role: [8]
                }
            ]
        },
        {
            name: 'Elektrik',
            url: '/elit',
            icon: 'fa fa-bolt',
            role: [1, 2, 7, 8, 10],
            children: [
                {
                    name: 'Choke / Gauge',
                    url: '/elit/choke',
                    role: []
                },
                {
                    name: 'Controller',
                    url: '/elit/controller',
                    role: []
                },
                {
                    name: 'Downhole Sensor',
                    url: '/elit/downhole-sensor',
                    role: []
                },
                {
                    name: 'Sinus',
                    url: '/elit/sinus',
                    role: []
                },
                {
                    name: 'Surface',
                    url: '/elit/surface',
                    role: []
                },
                {
                    name: 'Trafo',
                    url: '/elit/trafo',
                    role: []
                },
                {
                    name: 'VSD',
                    url: '/elit/vsd',
                    role: []
                }
            ]
        },
        {
            name: 'ESP',
            url: '/esp',
            icon: 'fa fa-wrench',
            role: [1, 2, 7, 8, 10],
            children: [
                {
                    name: 'Bolt Intake',
                    url: '/esp/bolt-intake',
                    role: []
                },
                {
                    name: 'Gas Separator',
                    url: '/esp/gas-separator',
                    role: []
                },
                {
                    name: 'Gas Handler',
                    url: '/esp/gas-handler',
                    role: []
                },
                {
                    name: 'Motor',
                    url: '/esp/motor',
                    role: []
                },
                {
                    name: 'Protector',
                    url: '/esp/protector',
                    role: []
                },
                {
                    name: 'Pump',
                    url: '/esp/pump',
                    role: []
                },
                {
                    name: 'Sand Trapper',
                    url: '/esp/sand-trapper',
                    role: []
                },
                {
                    name: 'Shroud',
                    url: '/esp/shroud',
                    role: []
                },
                {
                    name: 'Stator',
                    url: '/esp/stator',
                    role: []
                }
            ]
        },
        {
            name: 'Planner',
            url: '/plan',
            icon: 'fa fa-clipboard',
            role: [0, 1, 2, 7, 8, 10]
        },
        {
            name: 'SPK',
            url: '/spk',
            icon: 'fa fa-list',
            role: [0, 5, 6, 7, 8, 10]
        },
        {
            name: 'SPK Engine',
            url: '/spk-engine',
            icon: 'fa fa-list',
            role: [0, 3, 8]
        },
        {
            name: '-',
            url: '/spk-target',
            icon: 'fa fa-blank',
            role: [0]
        },
        {
            title: true,
            name: 'Master',
            role: [0, 1, 2, 7, 8, 10]
        },
        {
            name: 'Manufacturer',
            url: '/manufacturer',
            icon: 'fa fa-industry',
            role: [8]
        },
        // {
        //     name: 'Wilayah',
        //     url: '/wilayah',
        //     icon: 'fa fa-flag',
        //     role: [8]
        // },
        {
            name: 'Lokasi',
            url: '/lokasi',
            icon: 'fa fa-map-marker',
            role: [1, 2, 7, 8, 10]
        },
        {
            name: 'Users',
            url: '/user',
            icon: 'fa fa-user',
            role: [0]
        }
    ]
}
